import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-141ce3a3"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "discount-tickets"
};
var _hoisted_2 = {
  class: "tickets-wrapper"
};
var _hoisted_3 = {
  class: "bold-font"
};
var _hoisted_4 = {
  class: "full-height bold-font"
};
var _hoisted_5 = {
  class: "checkmark-style"
};
var _hoisted_6 = {
  class: "d-flex flex-row fl-s-b"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_col = _resolveComponent("el-col");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    title: _ctx.$t('discount.select-ticket'),
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        class: "cancel",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.cancelSelection();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_pagination, {
        background: "",
        small: "",
        layout: "prev, pager, next",
        total: _ctx.totalPssListLength,
        "current-page": _ctx.currentPage,
        onCurrentChange: _ctx.changeCurrentPage,
        "page-size": _ctx.pageSize
      }, null, 8, ["total", "current-page", "onCurrentChange", "page-size"]), _createVNode(_component_el_button, {
        type: "primary",
        class: "confirm",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.confirmSelection();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      })])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        "suffix-icon": "el-icon-search",
        placeholder: _ctx.$t('field.search'),
        modelValue: _ctx.ticketsQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.ticketsQuery = $event;
        }),
        onInput: _ctx.searchTickets
      }, null, 8, ["placeholder", "modelValue", "onInput"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchTickets, function (price) {
        return _openBlock(), _createBlock(_component_el_row, {
          key: price.priceId,
          onClick: function onClick($event) {
            return !_ctx.isPriceSelected(price.priceId) ? _ctx.selectDiscountTickets(price.priceId) : _ctx.deSelectDiscountTickets(price.priceId);
          },
          type: "flex",
          justify: "space-between",
          class: "ticket-row"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_col, {
              span: 18
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(price.categoryName), 1), _createTextVNode(" | " + _toDisplayString(price.priceType) + " | " + _toDisplayString(price.priceName), 1)])];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.currency + " " + price.priceValue / 100), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 2,
              class: _normalizeClass({
                'v-hidden': !_ctx.isPriceSelected(price.priceId)
              })
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", _hoisted_5, [_createVNode(_component_SvgIcon, {
                  iconContent: _ctx.iconContent,
                  iconAlt: _ctx.iconAlt,
                  iconStyle: _ctx.iconStyle
                }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])];
              }),
              _: 2
            }, 1032, ["class"])];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))])];
    }),
    _: 1
  }, 8, ["modelValue", "title"])]);
}